import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { themes, availableThemes } from "./themes.config";
import { getThemeFromUrl, getThemeFromCookie, setTheme } from "../themes/themes.service";
import CssBaseline from "@mui/material/CssBaseline";
import { DrawRounded } from "@mui/icons-material";
// class ThemeProvider extends React.PureComponent {
class AppThemeProvider extends React.PureComponent {
  constructor(props) {
    super(props);
      const { theme, setTheme } = this.props;
      
      const { dark } = themes;
    // const themeFromUrl = getThemeFromUrl(window.location.search);

    // if (themeFromUrl && themeFromUrl !== theme) {
    //   return setTheme(themeFromUrl);
    // }
    // setTheme(getThemeFromCookie());
      setTheme(dark.name);
  }

  render() {
      const { children, theme } = this.props;
    //   const { dark } = themes;
    return (
      <ThemeProvider theme={themes['dark'].theme}>
      {/* <ThemeProvider theme={dark.name}> */}
        <CssBaseline />
        {children}
      </ThemeProvider>
    );
  }
}

AppThemeProvider.propTypes = {
  theme: PropTypes.oneOf(availableThemes).isRequired
};

const mapStateToProps = (state) => ({
  theme: state.theme
});

export default connect(mapStateToProps, { setTheme })(AppThemeProvider);
